window.$ = require('jquery');

$(document).ready(function() {
    var stylesheetUrl = "https://cloud.typography.com/7260954/7721832/css/fonts.css";

    $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', stylesheetUrl));

});
